module.exports = __webpack_public_path__ + "img/minus.b93332d4.svg";